import React, { useState, useEffect } from "react";
import { Platform, StyleSheet } from "react-native";
import AppTheme from "../../AppTheme";
import { getStorageItem, setStorageItem } from "../../../../helpers/utils";

import moment from "moment";
import ManaMinutesDuration from "../../common/ManaMinutesDuration";

export default function TimeSpent() {
  const [duration, setDuration] = useState(null);

  useEffect(() => {
    getStorageItem("ONBOARDING_TIMER").then((startTs) => {
      const start = startTs
        ? moment.unix(startTs)
        : moment().add(-11, "minutes");
      const now = moment();

      const minutes = Math.max(1, now.diff(start, "minutes"))
      setDuration(minutes);
      setStorageItem("ONBOARDING_TIMER", null);
    });
  }, []);

  return duration ? (
    <ManaMinutesDuration minutes={duration} style={styles.hoursText} />
  ) : null;
}

const styles = StyleSheet.create({
  hoursText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 49,
    lineHeight: 60,
    letterSpacing: 0.6125,
    color: AppTheme.DEFAULT_COLOR,
    paddingTop: 0,
  },
});
